import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoConverterConfig } from '@/data/landingConfig/landingVideoConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoConverter } from './schemaObject';

interface Props {}
const VideoConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoConverter} />
			<VideoLandingTemplate
				data={landingVideoConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default VideoConverter;
